import styled from 'styled-components';
import { ButtonTertiary } from '@spotify-internal/encore-web';
export const IconButton = styled(ButtonTertiary) `
  color: ${props => props.$iconColor || '#fff'};
`;
